<template>
  <div>
    <!-- <textlen-config :config="curInput.editor" :limitMax="true"></textlen-config> -->
    <el-form ref="form" :model="curInput.editor" :rules="rules" label-width="100px">
      <el-form-item label="默认值" prop="write_default">
        <el-input v-model.trim="curInput.editor.write_default" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="pc端菜单配置" prop="pc_config">
        <el-checkbox v-model="curInput.editor.checkAllPcMenu" @change="checkAllChange(curInput.editor)">全选</el-checkbox>
        <el-checkbox-group v-model="curInput.editor.pc_config">
          <el-checkbox v-for="(item, index) in pcMenuType" :label="item.id" @change="isCheckAll(curInput.editor)">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="上传文件夹名（pc端)" prop="pc_dir_name" v-show="hasPcUpload()">
        <el-input v-model.trim="curInput.editor.pc_dir_name" class="h-40 w-200" placeholder="请填写上传文件夹名"></el-input>
      </el-form-item>
      <el-form-item label="文件大小限制（pc端)" prop="pc_file_max" v-show="hasPcUpload()">
        <el-input v-model.trim="curInput.editor.pc_file_max" class="h-40 w-100" placeholder="请填写文件大小"></el-input>
        <el-select v-model="curInput.editor.pc_file_unit" placeholder="请选择文件大小单位" class="h-40 w-100">
          <el-option v-for="(item, index) in fileUnit" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="百度地图秘钥（pc端)" prop="pc_map_key" v-show="hasMap()">
        <el-input v-model.trim="curInput.editor.pc_map_key" class="h-40 w-200" placeholder="请填写百度地图秘钥"></el-input>
      </el-form-item>
      <el-form-item label="默认代码类型（pc端)" prop="pc_code_type" v-show="hasCode()">
        <el-select v-model="curInput.editor.pc_code_type" placeholder="请选择默认代码类型" class="h-40 w-200">
          <el-option v-for="item in codeType" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="移动端菜单配置" prop="cell_config">
        <el-checkbox-group v-model="curInput.editor.cell_config">
          <el-checkbox v-for="(item, index) in cellMenuType" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="上传文件夹名（移动端)" prop="cell_dir_name" v-show="hasCellUpload()">
        <el-input v-model.trim="curInput.editor.cell_dir_name" class="h-40 w-200" placeholder="请填写上传文件夹名"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import modelConfig from '../../../config/modelConfig'
  import _verify from '../../../assets/js/verify'
  import textlenConfig from './textlenConfig'
  export default {
    props: ['curInput'],
    mixins: [modelConfig],
    data() {
      return {
        rules: {
          pc_dir_name: [
            { validator: this.checkChinese, trigger: 'blur' }
          ]
        },
        pcMenuType: [
          { id: 10, name: '图片上传' },
          { id: 20, name: '网络图片' },
          { id: 30, name: '插入视频' },
          { id: 40, name: '百度地图' },
          { id: 50, name: '插入代码' },
          { id: 60, name: '表情' }
        ],
        cellMenuType: [
          { id: 10, name: '图片上传' },
          { id: 60, name: '表情' }
        ],
        fileUnit: [
          { id: 10, name: 'KB' },
          { id: 20, name: 'MB' }
        ],
        codeType: ['apache', 'bash', 'coffeescript', 'cpp', 'cs', 'css', 'diff', 'http', 'ini', 'java', 'javascript', 'json', 'makefile', 'html', 'markdown', 'nginx', 'objectivec', 'perl', 'php', 'python', 'ruby', 'sql']
      }
    },
    components: {
      textlenConfig
    },
    created() {
      this.isCheckAll(this.curInput.editor)
    },
    methods: {
      hasPcUpload() {
        return _.findIndex(this.curInput.editor.pc_config, (res) => {
          return res == this.MENU_UPLOAD
        }) > -1
      },
      hasCellUpload() {
        return _.findIndex(this.curInput.editor.cell_config, (res) => {
          return res == this.MENU_UPLOAD
        }) > -1
      },
      hasMap() {
        return _.findIndex(this.curInput.editor.pc_config, (res) => {
          return res == this.MENU_MAP
        }) > -1
      },
      hasCode() {
        return _.findIndex(this.curInput.editor.pc_config, (res) => {
          return res == this.MENU_CODE
        }) > -1
      },
      checkAllChange(config) {
        if (config.checkAllPcMenu) {
          config.pc_config = []
          _.forEach(this.pcMenuType, (value, key) => {
            config.pc_config.push(value.id)
          })
        } else {
          config.pc_config = []
        }
      },
      isCheckAll(config) {
        if (config.pc_config.length != this.pcMenuType.length) {
          config.checkAllPcMenu = false
        } else {
          config.checkAllPcMenu = true
        }
      },
      checkChinese(rules, value, callback) {
        if (_verify.isChinese(value)) {
          callback('文件夹名不能为中文')
        } else {
          callback()
        }
      }
    },
    watch: {
      'curInput'() {
        this.isCheckAll(this.curInput.editor)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// editorConfig.vue?db05b83e